import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUser: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="user, people, person, member"><path d="M4.75 20.25V19.5C4.75 15.4959 7.99594 12.25 12 12.25C16.0041 12.25 19.25 15.4959 19.25 19.5V20.25H4.75Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="7.75" r="4.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconUser;
